import * as React from "react";
const SvgLong = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 9L9 1M9 1H3M9 1V7", stroke: "var(--color-green-500)", strokeLinecap: "round" }));
export default SvgLong;
